import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1352.68518,168.954824 L1352.68518,733.660706 L1917.39106,733.660706 L1917.39106,1750.13129 L675.038118,1750.13129 L675.038118,1072.48424 L216.158118,1072.48424 L489.136941,1345.46306 L409.174588,1425.31247 L-0.0112941176,1016.12659 L409.174588,606.827765 L489.136941,686.677176 L216.158118,959.543059 L675.038118,959.543059 L675.038118,168.954824 L1352.68518,168.954824 Z M1352.68518,959.543059 L787.979294,959.543059 L787.979294,1072.48424 L1352.68518,1072.48424 L1352.68518,959.543059 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.64894 620.776L1900.47247 620.776 1465.64894 185.839529z"
}));

var IconExportSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconExportSolid, _Component);

  var _super = _createSuper(IconExportSolid);

  function IconExportSolid() {
    _classCallCheck(this, IconExportSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconExportSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExport",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconExportSolid.displayName = "IconExportSolid";
  return IconExportSolid;
}(Component);

IconExportSolid.glyphName = 'export';
IconExportSolid.variant = 'Solid';
IconExportSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExportSolid;
export { IconExportSolid };